document.addEventListener('DOMContentLoaded', () => {
	// Get all inputs with data attribute data-action=search
	const searchInputs = document.querySelectorAll('[data-action=search]');

	const doSearch = (event) => {
		const {currentTarget} = event;
		const search = currentTarget.value;
		const url = currentTarget.dataset.url;

		// Preserve status filter if present
		const statusFilter = document.getElementById('filterJobStatus');
		const statusParam = statusFilter ? `&status=${statusFilter.value}` : '';

		window.location = `${url}?s=${search}${statusParam}`;
	}

	// Loop over them and add event listeners
	Array.prototype.slice.call(searchInputs)
		.forEach(function (input) {
			input.addEventListener('blur', function (event) {
				doSearch(event);
			});

			input.addEventListener('keyup', function (event) {
				if (event.keyCode === 13) {
					doSearch(event);
				}
			});
		});

	// Job status filter
	const statusFilter = document.getElementById('filterJobStatus');
	if (statusFilter) {
		statusFilter.addEventListener('change', function () {
			const url = this.dataset.url;
			const status = this.value;

			// Get current URL params to preserve date range
			const urlParams = new URLSearchParams(window.location.search);
			const dateStart = urlParams.get('date_start') || '';
			const dateEnd = urlParams.get('date_end') || '';

			let newUrl = `${url}?status=${status}`;
			if (dateStart && dateEnd) {
				newUrl += `&date_start=${dateStart}&date_end=${dateEnd}`;
			}

			window.location = newUrl;
		});
	}
});